export default __webpack_public_path__ + "static/media/logo1.8d533866.png";